import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Key } from 'lucide-react';

export const SplitBlock = () => {
  return (
    <section className="section-padding bg-[#07516B]" data-testid="split-section">
      <div className="container-custom">
        <div className="grid grid-cols-2 gap-3 md:gap-6">
          {/* B2B Block */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="relative overflow-hidden group"
          >
            <div className="absolute inset-0">
              <img loading="lazy"
                src="https://images.unsplash.com/photo-1770943558988-2c605d6bd5a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwd29ya3Nob3AlMjBtZWV0aW5nJTIwbW9kZXJuJTIwb2ZmaWNlJTIwZ2xhc3N8ZW58MHx8fHwxNzcyMTEzMDk5fDA&ixlib=rb-4.1.0&q=85"
                alt="Céges tréning vezetői csapatnak — Az Akadémia"
                className="w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/40" />
            </div>
            <div className="relative z-10 p-4 md:p-10 lg:p-14 min-h-[200px] md:min-h-[400px] flex flex-col justify-end">
              <Building2 className="text-brand-light-green mb-2 md:mb-6 w-6 h-6 md:w-9 md:h-9" />
              <h3 className="font-heading text-base md:text-3xl lg:text-4xl font-semibold text-white mb-2 md:mb-4 break-words hyphens-auto">
                Céges tréningek
              </h3>
              <p className="text-white/70 text-xs md:text-lg mb-3 md:mb-6 max-w-md hidden md:block">
                Testreszabott fejlesztési programok vállalatoknak. A csapatod hatékonysága 
                nem a létszámon, hanem az együttműködésen múlik.
              </p>
              <Link
                to="/b2b"
                className="inline-flex items-center gap-1 md:gap-2 text-sm md:text-base text-brand-light-green hover:text-white font-semibold transition-colors group/link"
                data-testid="split-cta-b2b"
              >
                Ajánlatkérés
                <ArrowRight size={18} className="group-hover/link:translate-x-1 transition-transform" />
              </Link>
            </div>
          </motion.div>

          {/* Real Estate Block */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="relative overflow-hidden group"
          >
            <div className="absolute inset-0">
              <img loading="lazy"
                src="https://images.pexels.com/photos/18435276/pexels-photo-18435276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Modern budapesti ingatlan — ingatlanközvetítői képzés"
                className="w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/40" />
            </div>
            <div className="relative z-10 p-4 md:p-10 lg:p-14 min-h-[200px] md:min-h-[400px] flex flex-col justify-end">
              <Key className="text-brand-light-green mb-2 md:mb-6 w-6 h-6 md:w-9 md:h-9" />
              <h3 className="font-heading text-base md:text-3xl lg:text-4xl font-semibold text-white mb-2 md:mb-4 break-words hyphens-auto">
                Ingatlanközvetítői képzés
              </h3>
              <p className="text-white/70 text-xs md:text-lg mb-3 md:mb-6 max-w-md hidden md:block">
                Szakmai alapok és gyakorlati tudás az ingatlanpiacon való sikeres induláshoz. 
                Mentorálás, ügyféllista, folyamatos támogatás.
              </p>
              <Link
                to="/ingatlan"
                className="inline-flex items-center gap-1 md:gap-2 text-sm md:text-base text-brand-light-green hover:text-white font-semibold transition-colors group/link"
                data-testid="split-cta-realestate"
              >
                Részletek
                <ArrowRight size={18} className="group-hover/link:translate-x-1 transition-transform" />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
